export default __webpack_public_path__ + "static/media/bricks.6b69e2f6.png";